// Tells Sentry which customer hit an error, by Firebase uid only - no email or
// name - so an issue shows how many customers it affects, not just how many
// events. Follows the user store rather than changing it: SET_USER is how login,
// session restore and logout (SET_USER({})) all reach the store.
export default ({ store, $sentry }) => {
  if (!$sentry) return

  const apply = (user) => {
    $sentry.setUser(user && user.uid ? { id: user.uid } : null)
  }

  apply(store.state.user && store.state.user.user)
  store.subscribe((mutation) => {
    if (mutation.type === 'user/SET_USER') apply(mutation.payload)
  })
}
